import { Component } from '@angular/core';

@Component({
  selector: 'icon-minimize',
  standalone: true,
  template: `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_29_447" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="4" y="4" width="24" height="24">
            <rect x="4" y="4" width="24" height="24" fill="#0B2C2D"/>
        </mask>
        <g mask="url(#mask0_29_447)">
            <path d="M8.425 25L7 23.575L11.6 19H9V17H15V23H13V20.4L8.425 25ZM17 15V9H19V11.6L23.575 7L25 8.425L20.4 13H23V15H17Z" fill="#1C6E70"/>
        </g>
    </svg>
  `,
  styles: [
   `
    svg {
        path {
          fill: var(--main-color);
        }
      }

      svg:hover {
        path {
          fill: var(--main-color-strong);
        }
      }
    `
  ]
})

export class MinimizeIconComponent {

}
